module.exports = __webpack_public_path__ + "pc/img/swiper_logo_02.0bd0891a.png";